import { TableBody, TableCell } from '@material-ui/core'
import React, { useEffect } from 'react'
import { useAttendance } from '../../../hooks/Features/useAttendance'
import { itemsPerPage } from '../../../shared/data'
import CustomHeading from '../../CustomHeading'
import CustomPagination from '../../CustomPagination'
import Layout from '../../Layout'
import Loader from '../../Loader'
import CustomTable from '../../Table/CustomTable'
import CustomTableHeading from '../../Table/CustomTableHeading'
import CustomTableRow from '../../Table/CustomTableRow'
import styles from '../reports.module.css'
import { NoDataFound } from '../../NoDataFound'
import { useLead } from '../../../hooks/Features/useLeads'
import { formatDate, formatNumber } from '../../../shared/constants'
import { SortIcon, FilterIcon } from '../../CustomComponents/CustomFilterIcon'

export default function LeadStatusReport() {
  const { loading, getLeadStatusReport, lead } = useLead()
  const [page, setPage] = React.useState(1)
  const startDate = new Date()
  startDate.setDate(1)
  startDate.setHours(0, 0, 0)
  const [from, setFrom] = React.useState(startDate)
  const [to, setTo] = React.useState(new Date())

  useEffect(() => {
    setPage(1)
    getLeadStatusReport({ from: from, to: to })
  }, [from, to])

  const noOfPages = Math.ceil(lead && lead.length / itemsPerPage)
  const handleChange = (event, value) => {
    setPage(value)
  }


  const heading = [
    { label: 'Lead Status', key: 'ls' },
    { label: 'Promoter Name', key: 'pn' },
    { label: 'Outlet', key: 'ol' },
    { label: 'Region', key: 'region' },
    { label: 'Zone', key: 'zone' },
    { label: 'State', key: 'state' },
    { label: 'District', key: 'district' },
    { label: 'city', key: 'city' },
    { label: 'TSM', key: 'tsm' },
    { label: 'Lead Date', key: 'ld' },
    { label: 'Likely Closure Date', key: 'lcd' },
    { label: 'Expected Order Value', key: 'eov' },
    { label: 'Customer Name', key: 'cn' },
    { label: 'Customer Phone No.', key: 'cp' },
    { label: 'Customer E-Mail', key: 'cm' },
    { label: 'Customer Address', key: 'ca' },
  ]

  let tempLead = []
  lead &&
    lead.forEach((item) =>
      tempLead.push({
        ls: item.status,
        pn: item.rank6Name,
        ol: item.outlet,
        region: item.region && item.region.name,
        zone: item.zone && item.zone.name,
        state: item.state && item.state.name,
        district: item.district && item.district.name,
        city: item.city && item.city.name,
        tsm: item.rank5Name,
        ld: formatDate(item.leadDate),
        lcd: formatDate(item.closureDate),
        eov: formatNumber(item.orderValue),
        cn: item.customer.name,
        cp: item.customer.mobile,
        cm: item.customer.email,
        ca: item.customer.address,
      })
    )

  return (
    <Layout
      heading="Lead Status Report"
      none
      selectedFrom={from}
      setSelectedFrom={setFrom}
      selectedTo={to}
      setSelectedTo={setTo}
      headers={heading}
      data={tempLead ? tempLead : []}
      tempHeaderData={[]}
      filename='lead_status_report'
    >
      <CustomTable padding className={styles.table}>
        <CustomTableHeading
          heading={[
            'LEAD STATUS',
            'PROMOTER NAME',
            'OUTLET',
            'REGION',
            'ZONE',
            'STATE',
            'DISTRICT',
            'CITY',
            'TSM',
            'LEAD DATE',
            'LIKELY CLOSURE DATE',
            'EXPECTED ORDER VALUE',
            'CUSTOMER',
          ]}
          columnSpan={{ CUSTOMER: 4 }}
        />
        <CustomTableRow className={styles.subHead}>
          <TableCell colSpan={12}></TableCell>
          <TableCell>Name</TableCell>
          <TableCell>Phone No.</TableCell>
          <TableCell>E-Mail</TableCell>
          <TableCell>Address</TableCell>
        </CustomTableRow>
        <TableBody className={styles.tr}>
          {!loading &&
            lead.length > 0 &&
            lead.slice((page - 1) * itemsPerPage, page * itemsPerPage).map((item, index) => {
              return (
                <CustomTableRow>
                  <TableCell className={styles.region}>{item.status}</TableCell>
                  <TableCell>{item.rank6Name}</TableCell>
                  <TableCell>{item.outlet}</TableCell>
                  <TableCell>{item.region ? item.region.name : ''}</TableCell>
                  <TableCell>{item.zone ? item.zone.name : ''}</TableCell>
                  <TableCell>{item.state ? item.state.name : ''}</TableCell>
                  <TableCell>{item.district ? item.district.name : ''}</TableCell>
                  <TableCell>{item.city ? item.city.name : ''}</TableCell>
                  <TableCell>{item.rank5Name}</TableCell>
                  <TableCell>{formatDate(item.leadDate)}</TableCell>
                  <TableCell>{formatDate(item.closureDate)}</TableCell>
                  <TableCell>{formatNumber(item.orderValue)}</TableCell>
                  <TableCell>{item.customer.name ? item.customer.name : ''}</TableCell>
                  <TableCell>{item.customer.mobile ? item.customer.mobile : ''}</TableCell>
                  <TableCell>{item.customer.email ? item.customer.email : ''}</TableCell>
                  <TableCell>{item.customer.address ? item.customer.address : ''}</TableCell>
                </CustomTableRow>
              )
            })}
        </TableBody>
      </CustomTable>
      {loading && <Loader />}
      {!loading && lead.length > 0 && (
        <CustomPagination noOfPages={noOfPages} page={page} handleChange={handleChange} />
      )}

      {!loading && lead.length === 0 && <NoDataFound />}
    </Layout>
  )
}
